import styled from "styled-components";

export const Container = styled.div`
  /* max-width: 1411px; */
  padding: 20px 0 28px 0;
  width: 100%;
  margin: 0 auto;
  .dummy-div{
    height: 52px;
  }
  @media (max-width: 1024px) {
    .dummy-div{
      height: 10px;
    }
  }
`;

export const TopHeader = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1411px;
    margin: 0 auto;
    padding: 9px 27px;
    h6{
    font-size: 19px;
    font-weight: bold;
    align-self: center;
    }
    @media (max-width: 1250px) {
    padding: 9px 13px;
    }
`

export const Wrapper = styled.div`
  position: relative;
  max-width: 1411px;
  margin: 0 auto;
  /* padding: 0 25px; */
  .MuiAppBar-colorPrimary{
    padding-bottom: 15px;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 1024px) {
    top: 0px;
  }
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`

export const InputFieldsWrapper = styled.div`
    .css-os3nnz-control,.css-1lmoifu-control{
        border-top: none;
        border-right: none;
        border-left: none;
        border-image: initial;
        border-bottom: 1px solid rgb(225, 225, 225);
        border-radius: 0px;
        padding: 0px;
    }
    .css-1r0b6xv-control:hover{
        border-top: none;
        border-right: none;
        border-left: none;
        border-image: initial;
        border-bottom: 1px solid rgb(225, 225, 225);
        border-radius: 0px;
        padding: 0px;
        border: none;
        box-shadow: none;
        border-radius: 0;
        border-color: white !important;
    }
    input{
        border: none;
        border-bottom: 1px solid #e1e1e1;
        border-radius: 0;
        padding: 0;
    }
    .file-input-wrapper .MuiFormControl-root{
        border:none;
        height: 0;
    }
    .custom-date-piker .MuiIconButton-root .MuiIconButton-label{
        margin-bottom: 5px;
    }
    .MuiInputBase-root{
        input{
            padding-bottom: 8px;
        }       
    }
    .css-4ljt47-MenuList {
        max-height: 180px;
    }
`;

export const Footer = styled.div`
  margin-top: clamp(15px, 1.042vw, 20px);
  button {
    margin: 0 auto;
    height: clamp(30px, 1.875vw, 36px);
    padding: 0 20px;
    border-radius: 5px;
    background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
    font-size: clamp(12px, 0.833vw, 16px) !important;
  }
  button:hover {
    // opacity: 0.4;
  }
`;

export const TopHeading = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(11px, 0.781vw, 15px);
  align-items: center;
  padding: clamp(10px, 0.833vw, 16px) 0;

 

  h4 {
    font-size: clamp(12px, 0.833vw, 16px);
    /* line-height: 24px; */
    letter-spacing: 0.005em;
    color: #005586;
    font-family: "latobold";
    margin: clamp(3px, 0.26vw, 5px) 0;
  }
  p {
    font-size: clamp(10px, 0.729vw, 14px);
    /* line-height: 19px; */
    letter-spacing: 0.005em;
    color: rgba(17, 17, 17, 0.8);
    margin: clamp(3px, 0.26vw, 5px) 0;
  }
`;

export const OuterWrapper = styled.div`
  padding: 0 clamp(60px,4.688vw,90px) 30px;
  min-height: calc(100vh - 82px);
  max-width: 1920px;
  margin: 0 auto;/
`;

export const FormWrapper = styled.div`
    padding: 25px;
    background: #FFFFFF;
    border: 1.5px solid rgba(211, 211, 211, 0.5);
    border-radius: 15px;
    max-height: calc(100vh - clamp(187px,10.417vw,200px));
    /* overflow: auto; */
    display: flex;
    flex-direction: column;
    /* border: 1.5px solid #00558680; */
    box-shadow: 0px 7px 4.5px 0px #0000000D;
    /* background: linear-gradient(176.81deg, #FFFFFF 4.22%, #E9F8FF 97.36%); */
   .loan-detail-wrapper {
    display: grid;
    align-items: flex-end;
    grid-template-columns: 1fr 1fr 2fr 1fr;
    gap: clamp(30px,2.083vw,40px);
    .other-label{
        position: absolute;
        bottom: 35px;
        font-size: 12px;
    }
    .qty-label{
        position: absolute;
        bottom: 35px;
        font-size: 12px;
    }
    /* > button {
        height: clamp(27px,1.875vw,36px);
        width: clamp(80px,5.417vw,104px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: clamp(10px,0.729vw,14px);
        background: #FFFFFF;
        border: 1px solid #303030;
        border-radius: clamp(27px,1.875vw,36px);
        gap: 5px;
        > svg {
            width: clamp(11px,0.781vw,15px);
            height: clamp(11px,0.781vw,15px);
        }
        &.add-more {
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            border-color: transparent;
            color: #fff;
        }
    } */
   }
   .comment-section{
        grid-template-columns: 5fr;
        gap: clamp(15px,2.083vw,40px);
   }   
   .app-input-text {
        margin-bottom: 0px;
    }
   .business-name-wrapper {
    display: flex;
    gap: min(1.1vw, 102px);
    align-items: flex-end;
    margin-top: 10px;
        > .app-input-text {
            width: 100%;
            max-width: 896px;
        }
        .custom-select__control{
            border-bottom: 1px solid rgb(224, 224, 224);  
        }
        .equipment-requirements-wrapper {
            max-width: 576px;
            width: 100%;
            margin-right: 50px;
            margin-bottom: 10px;
            .requirements-checkbox {
                margin-right: 100px;
                display: flex;
                justify-content: space-between;
                .radio-checkmark{
                    width: 18px;
                    height: 18px;
                    border-radius: 0px;
                    }
                .radio-checkmark:after {
                    top: 2px;
                    left: 2px;
                    width: 12px;
                    height: 12px;
                    border-radius: 0px;
                }
            }
        }
        .uploadPhoto {
            > div {
                max-width: 204px;
                > span {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    > div {
        display: flex;
        gap: clamp(20px, 6.25vw, 120px);
        > div {
            flex: 1;
            min-width: 860px;
            :nth-child(2) {
                max-width: 655px;
                min-width: auto;
            }
    }
    }
    .sec-label {
        font-size: clamp(12px,0.833vw,16px);
        /* line-height: 19px; */
        letter-spacing: 0.005em;
        color: #000;
        font-family: "latobold";
        margin-bottom: 15px;
    }
    .label-heading {
        font-weight: 700;
        font-size: clamp(14px,0.833vw,16px);
        line-height: normal;
        letter-spacing: 0.005em;
        color: #005586;
    }
    .label-heading-lots{
        margin-bottom: 24px;
    }
    .button-wrapper{
        display: flex;
        gap: 10px;
        justify-content: center;
        button{
            margin: 0px;
            width: 170px;
            padding: 0 15px;
        }
        .disabled-button{
            opacity: 0.5;
        }
    }
    .reset-button{
        background: #E4E3E3 !important;
        border: none !important;
    }
    .submit-button{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%) !important;
        border: none !important;
        color: #fff;
    }
    .update-button{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%) !important;
        border: none !important;
        color: #fff;
        width: 210px !important;
    }
    .react-select__single-value{
        font-size: 13px;
    }
    @media (max-width: 1626px) {
        > div {
            > div {
                min-width: 730px;
            }
        }
    }
    @media (max-width: 1478px) {
        > div {
            gap: 40px;
            > div {
                min-width: auto;
            }
        }
    }
    @media (max-width: 1277px) {
        > div {
            > div {
                min-width: 565px;
            }
        }
    }
    .star {
    color: red;
    }
`

export const DatePickerStyled = styled.div`
  height: 37px;
  padding-top: 7px;
  width: 100%;
  .file-input-wrapper .MuiFormControl-root .MuiInput-root {
    padding-left: 0;
    padding-right: 0;
  }
`;